import { loadStripe } from '@stripe/stripe-js';

const flag = (value) => String(value || '').toLowerCase() === 'true';

const STRIPE_TEST_MODE = flag(process.env.REACT_APP_STRIPE_TEST_MODE);
const STRIPE_TEST_KEY = process.env.REACT_APP_STRIPE_TEST_KEY || 'pk_test_RHKZ0zStVptPQTlKXqJSLgGv';
const STRIPE_LIVE_KEY = process.env.REACT_APP_STRIPE_LIVE_KEY || 'pk_live_placeholder';

export const stripePromise = loadStripe(STRIPE_TEST_MODE ? STRIPE_TEST_KEY : STRIPE_LIVE_KEY);
